<template>
  <nav
    :class="{sidebar: true, sidebarStatic, sidebarOpened, staging: current_env}"
    @mouseenter="sidebarMouseEnter"
    @mouseleave="sidebarMouseLeave"
  >
    <header class="logo">
      <router-link to="/app/deals"><span class="thumb-xxl mr-2" :class="sidebarStatic || sidebarOpened ? '':'sml' ">
            <!-- <img class="" src="../../assets/img/Logo.png" alt="..." /> -->
            <img class="" v-if="sidebarStatic || sidebarOpened " src="../../assets/img/Anlyst_logo.svg" alt="..." />
            <img class="" v-else src="../../assets/img/Anlyst-logo-icon.svg" alt="..." />

          </span></router-link>
    </header>
    <ul class="nav" v-if="navLinks.length">
      <NavLink v-for="navLink in navLinks" 
        v-if="!navLink.hidden"
        :activeItem="navLink.activeItem ? activeItem : ''"
        :header="navLink.header"
        :link="navLink.link"
        :iconName="navLink.icon"
        :index="navLink.index"
        :childrenLinks="navLink.childrenLinks ? navLink.childrenLinks : null"
        :isHeader="navLink.isHeader ? navLink.isHeader : false"
      />
    </ul>
    <!-- <p>
    <h5 class="navTitle">
      LABELS
      <a class="actionLink">
        <i class="la la-plus float-right" />
      </a>
    </h5>
    <ul class="sidebarLabels">
      <li>
        <a href="#">
          <i class="fa fa-circle text-warning mr-2" />
          <span class="labelName">My Recent</span>
        </a>
      </li>
      <li>
        <a href="#">
          <i class="fa fa-circle text-gray mr-2" />
          <span class="labelName">Starred</span>
        </a>
      </li>
      <li>
        <a href="#">
          <i class="fa fa-circle text-danger mr-2" />
          <span class="labelName">Background</span>
        </a>
      </li>
    </ul>
    <h5 class="navTitle">
      PROJECTS
    </h5>
    <div class="sidebarAlerts">
      <b-alert
        v-for="alert in alerts"
        :key="alert.id"
        class="sidebarAlert" variant="transparent"
        show dismissible
      >
        <span>{{alert.title}}</span><br />
        <b-progress class="sidebarProgress progress-xs mt-1"
          :variant="alert.color" :value="alert.value" :max="100" />
        <small>{{alert.footer}}</small>
      </b-alert>
    </div> -->
  </nav>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import isScreen from '@/core/screenHelper';
import NavLink from './NavLink/NavLink';
import common from '@/assets/js/common.js';

export default {
  name: 'Sidebar',
  components: { NavLink },
  mixins: [common],
  data() {
    return {
      current_env: (process.env.VUE_APP_NODE_ENV == 'testing'),
      alerts: [
        {
          id: 0,
          title: 'Sales Report',
          value: 15,
          footer: 'Calculating x-axis bias... 65%',
          color: 'info',
        },
        {
          id: 1,
          title: 'Personal Responsibility',
          value: 20,
          footer: 'Provide required notes',
          color: 'danger',
        },
      ],
      navLinks: [
        {
          header: "Dashboard",
          link: "/app/dashboard",
          icon: "fi flaticon-home",
          index: "dashboard",
          isHeader : true
        },
        {
          header: "Users",
          link: "/app/users",
          icon: "fi flaticon-user",
          index: "users",
          isHeader : true,
          hidden: !this.can_access('user','view')
        },
        {
          header: "Clients",
          link: "/app/customers",
          icon: "fa fa-address-card-o",
          index: "customers",
          isHeader : true,
          hidden: !this.can_access('customer','view')
        },
        {
          header: "Client Reports",
          link: "/app/client_reports",
          icon: "fa fa-bar-chart-o",
          index: "reports",
          isHeader : true,
          hidden: !this.can_access('report','view')
        },
        {
          header: "Counterparty/Custodian",
          link: "/app/broker_deals",
          icon: "fi fa-ticket",
          index: "broker_deals",
          isHeader : true,
          hidden: !this.can_access('broker_deal','view')
        },
        {
          header: "Client Deal Tickets",
          link: "/app/deals",
          icon: "fi fa-ticket",
          index: "adddeals",
          isHeader : true,
          hidden: !this.can_access('deal','view')
        },
        {
          header: "Company P&L",
          link: "/app/company_pnl",
          icon: "fi fa-ticket",
          index: "broker_deals",
          isHeader : true,
          hidden: !this.can_access('broker_deal','view')
        },
        {
          header: "Control Reports",
          link: "/app/control_reports",
          icon: "fa fa-bar-chart-o",
          index: "reports",
          isHeader : true,
          hidden: !this.can_access('report','view')
        },
        {
          header: "Market Value",
          link: "/app/marketvalues",
          icon: "fi fa-database",
          index: "marketValue",
          isHeader : true,
          hidden: !this.can_access('marketvalue','view')
        },
        {
          header: "FX Rate",
          link: "/app/fxrates",
          icon: "fa fa-money",
          index: "FXRate",
          isHeader : true,
          hidden: !this.can_access('fxrate','view')
        },
        {
          header: "Deposit/Withdraw",
          link: "/app/transactions",
          icon: "fa fa-credit-card",
          index: "transaction",
          isHeader : true,
          hidden: !this.can_access('transaction','view')
        },
        {
          header: "Securities",
          link: "/app/stock",
          icon: "fa fa-credit-card",
          index: "stock",
          isHeader : true,
          hidden: !this.can_access('stock','view')
        },
        {
          header: "Email Server",
          link: "/app/email_server",
          icon: "fa fa-envelope",
          index: "email_server",
          isHeader : true,
          hidden: !this.can_access('email','view')
        },
        {
          header: "Event Register",
          link: "/app/event_register",
          icon: "fa fa-calendar",
          index: "event_register",
          isHeader : true,
          hidden: !this.can_access('event_register','view')
        },
        {
          header: "FD Rate",
          link: "/app/fdrates",
          icon: "fa fa-money",
          index: "FDRate",
          isHeader : true,
          hidden: !this.can_access('fdrate','view')
        },
        /*{
          header: "Typography",
          link: "/app/typography",
          icon: "flaticon-list",
          index: "typography",
          isHeader : true
        },
        {
          header: "Tables Basic",
          link: "/app/tables",
          icon: "flaticon-equal-1",
          index: "tables",
          isHeader : true
        },
        {
          header: "Notifications",
          link: "/app/notifications",
          icon: "flaticon-star",
          index: "notifications",
          isHeader : true
        },
        {
          activeItem:true,
          header: "Components",
          link: "/app/components",
          icon: "flaticon-network",
          index: "components",
          childrenLinks: [
            { header: 'Charts', link: '/app/components/charts' },
            { header: 'Icons', link: '/app/components/icons' },
            { header: 'Maps', link: '/app/components/maps' },
          ]
        }*/
      ]
    };
  },
  methods: {
    ...mapActions('layout', ['changeSidebarActive', 'switchSidebar']),
    setActiveByRoute() {
      const paths = this.$route.fullPath.split('/');
      paths.pop();
      this.changeSidebarActive(paths.join('/'));
    },
    sidebarMouseEnter() {
      if (!this.sidebarStatic && (isScreen('lg') || isScreen('xl'))) {
        this.switchSidebar(false);
        this.setActiveByRoute();
      }
    },
    sidebarMouseLeave() {
      if (!this.sidebarStatic && (isScreen('lg') || isScreen('xl'))) {
        this.switchSidebar(true);
        this.changeSidebarActive(null);
      }
    },
  },
  created() {
    this.setActiveByRoute();
  },
  computed: {
    ...mapState('layout', {
      sidebarStatic: state => state.sidebarStatic,
      sidebarOpened: state => !state.sidebarClose,
      activeItem: state => state.sidebarActiveElement,
    }),
  },
};
</script>

<!-- Sidebar styles should be scoped -->
<style src="./Sidebar.scss" lang="scss" scoped/>
